import { ID } from "src/libs/interfaces/layouts";
import { ILandingCategory } from "../../data/interfaces";
import { useLandingStore } from "../../data/store";

export default function getCatsWithChildren(ids: ID[]): ID[] {
    const landing = useLandingStore.getState().currentLanding
    const categories: ILandingCategory[] = landing.categories || []
    let catIds: ID[] = []
    ids.forEach(id => {
        catIds.push( id ) 
        catIds = [ ...catIds, ...getChildrenCats( id, categories ) ]
    })
    return catIds
}

export function getChildrenCats(id: ID, categories: ILandingCategory[] = []): ID[] { 
    let catIds: ID[] = []
    const children = categories.filter( c => c.parentId === id).map(c => c.id )
    catIds = [ ...catIds, ...children ]
    children.forEach( _id => {
        catIds = [ ...catIds, ...getChildrenCats( _id,categories ) ]
    })
    return catIds
}

export const getParents = (id:ID): ID[] => {
    const landing = useLandingStore.getState().currentLanding
    const categories: ILandingCategory[] = landing.categories || []
    let catIds: ID[] = []
    categories.forEach(cat => {
        catIds = [ ...catIds, ...getParentCat( cat, categories ) ]
    })
    
    return catIds
}

export const getParentCat = ( cat: ILandingCategory, categories: ILandingCategory[] ): ID[] => {
    let catIds: ID[] = [ cat.id ]
    if( !!cat.parentId ) {
        catIds.push( cat.parentId )
    }
    
    return [...catIds, ]
}